"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { browserFirstTouchAttribution } from "@/lib/campaign-attribution";
import { syncPublicGoogleAnalyticsPath } from "@/lib/google-analytics";
import { syncPublicAnalyticsPath } from "@/lib/posthog-client";
import { isPublicTelemetryPath } from "@/lib/telemetry";

export function PublicTelemetry() {
  const pathname = usePathname();

  useEffect(() => {
    if (isPublicTelemetryPath(pathname)) browserFirstTouchAttribution();
    syncPublicAnalyticsPath(pathname);
    syncPublicGoogleAnalyticsPath(pathname);
  }, [pathname]);

  return null;
}
